import { render, staticRenderFns } from "./FormControlsList.vue?vue&type=template&id=4ffe3b32&scoped=true"
import script from "./FormControlsList.vue?vue&type=script&lang=js"
export * from "./FormControlsList.vue?vue&type=script&lang=js"
import style0 from "./FormControlsList.vue?vue&type=style&index=0&id=4ffe3b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe3b32",
  null
  
)

export default component.exports